const menuConfig = {
  '/': [
    { label: 'navbar.home', href: '#hero' },
    { label: 'navbar.showcase', href: '#showcase' },
    { label: 'navbar.howItWorks', href: '#how-it-works' },
    { label: 'navbar.why', href: '#why' },
    { label: 'navbar.join', href: '#partner' },
    { label: 'navbar.download', href: '#cta' },
  ],
  '/invitation': [
    { label: 'navbar.home', href: '/' },
    { label: 'navbar.download', href: '/download' },
    { label: 'navbar.privacy', href: '/privacy' },
  ],
  '/download': [
    { label: 'navbar.home', href: '/' },
    { label: 'navbar.privacy', href: '/privacy' },
  ],
  '/privacy': [
    { label: 'navbar.home', href: '/' },
    { label: 'navbar.download', href: '/download' },
  ],
  '/launch-button': [
    { label: 'navbar.countdown', href: '/countdown' },
    { label: 'navbar.countdownDirect', href: '/countdown-direct' },
    { label: 'navbar.home', href: '/' },
  ],
  '/countdown': [
    { label: 'navbar.home', href: '/' },
    { label: 'navbar.download', href: '/download' },
  ],
  '/countdown-direct': [
    { label: 'navbar.home', href: '/' },
    { label: 'navbar.download', href: '/download' },
  ],

  // fallback default
  default: [
    { label: 'navbar.home', href: '/' },
    { label: 'navbar.download', href: '/download' },
    { label: 'navbar.privacy', href: '/privacy' },
  ]
};

export default menuConfig;
